import { Check, Camera, LayoutGrid, MessageCircle, BookOpen, Sparkles } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";
import { SubscribeButton } from "./SubscribeButton";
import { ReferralInput } from "./ReferralInput";

const INCLUDED = [
  "Shooting fotografico iniziale incluso: scatti professionali dedicati alla tua attività",
  "3 contenuti pronti da postare ogni mese: grafiche, descrizioni e hashtag personalizzati e pronti da copiare e postare",
  "Assistente AI in collaborazione con Mirlo's Company, addestrato per risponderti da vero esperto marketing",
  "Guida pratica per realizzare contenuti extra in autonomia, in pochi minuti",
];

const LIMITS = [
  { value: "10", label: "Idee mensili extra per TE, pronte da usare quando vuoi" },
  { value: "3", label: "Contenuti pronti da postare ogni mese (post, didascalie e hashtag pronti!)" },
  { value: "AI", label: "Addestrata per risponderti come un esperto marketing" },
  { value: "ADS", label: "Guida su come aumentare le vendite e come creare le ADS senza pagare un esterno" },
];

const FEATURES = [
  { icon: Sparkles, label: "Piattaforma AI completa" },
  { icon: BookOpen, label: "Manuali & guide pratiche" },
  { icon: LayoutGrid, label: "Bacheca e calendario contenuti" },
];

export const Benefits = () => (
  <section id="soluzione" data-testid="benefits-section" className="mx-auto max-w-6xl px-5 py-12">
    <Chapter number="02" label="La soluzione — Starter Pack" />
    <Reveal>
      <div
        data-testid="benefits-box"
        className="relative overflow-hidden rounded-3xl border-2 border-purple-600 bg-purple-50/70 p-6 shadow-2xl shadow-purple-600/10 ring-1 ring-purple-400/20 sm:p-8"
      >
        <div className="flex flex-wrap items-center justify-center gap-3 text-center">
          <span className="inline-block rounded-full bg-purple-600 px-4 py-1 text-[11px] font-semibold uppercase tracking-widest text-white">
            Starter Pack · 997€/anno
          </span>
          <span className="text-xs font-semibold text-purple-700">365 giorni · tutto incluso</span>
        </div>
        <h2 className="mt-5 text-center font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Sii presente sui social{" "}
          <span className="text-purple-600">a meno di 83€ al mese.</span>
        </h2>

        <ul className="mt-6 grid gap-4 sm:grid-cols-2">
          {INCLUDED.map((item, i) => (
            <Reveal key={item} delay={i * 0.08}>
              <li data-testid={`benefit-item-${i}`} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-purple-600">
                  <Check className="h-4 w-4 text-white" />
                </span>
                <p className="text-base font-medium leading-relaxed text-slate-800">{item}</p>
              </li>
            </Reveal>
          ))}
        </ul>

        <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {LIMITS.map((l, i) => (
            <div
              key={l.label}
              data-testid={`limit-stat-${i}`}
              className="rounded-2xl border border-purple-200 bg-white p-4 text-center shadow-sm"
            >
              <p className="font-heading text-3xl font-extrabold text-purple-600">{l.value}</p>
              <p className="mt-1 text-xs font-medium text-slate-500">{l.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {FEATURES.map((f) => (
            <span
              key={f.label}
              data-testid={`feature-chip-${f.label.split(" ")[0].toLowerCase()}`}
              className="inline-flex items-center gap-2 rounded-full border border-purple-300 bg-white px-4 py-2 text-sm font-semibold text-purple-800"
            >
              <f.icon className="h-4 w-4 text-purple-600" />
              {f.label}
            </span>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center gap-5 border-t border-purple-200 pt-6 text-center sm:flex-row sm:justify-between sm:text-left">
          <div>
            <p className="font-heading text-3xl font-extrabold text-slate-900">
              997€<span className="text-base font-semibold text-slate-400"> / anno</span>
            </p>
            <p className="mt-1 flex items-center justify-center gap-2 text-sm text-slate-500 sm:justify-start">
              <Camera className="h-4 w-4 text-purple-500" /> Shooting fotografico iniziale compreso nel prezzo
            </p>
          </div>
          <SubscribeButton testid="benefits-subscribe-cta-button" />
        </div>
        <div className="mt-4 flex justify-center sm:justify-end">
          <ReferralInput suffix="benefits" />
        </div>
      </div>
    </Reveal>
  </section>
);
